module.exports = __webpack_public_path__ + "media/partners/lpg-68499600.svg";